import React from 'react'

import { useMediaQueryContext } from '@fourthwall/components'
import { routing } from '@utils/routing'

import type { Incentive as IncentiveType } from '../../../../Recommendations.types'
import { getBonus } from '../../utils'
import { Incentive } from '../Incentive'

type Props = {
  incentive: Extract<IncentiveType, { type: 'ORDER_SAMPLES' }>
}

export const SamplesIncentive = ({ incentive }: Props) => {
  const { tablet } = useMediaQueryContext()

  return (
    <Incentive
      type={incentive.type}
      icon="🛍️"
      label="Order your holiday samples"
      isCompleted={incentive.isCompleted}
      bonus={getBonus(incentive.bonus)}
      button={{
        label: tablet ? 'Order samples' : 'Order',
        to: routing.settings.samples.order,
      }}
    />
  )
}
